import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    width: "100%",
    backgroundColor: "#F4F6F8",
    fontFamily: "'Lato', 'Segoe UI', sans-serif",
  },
  content: {
    width: "100%",
    maxWidth: 760,
    margin: "0 auto",
    paddingTop: theme.spacing(13),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(5),
    boxSizing: "border-box",
  },
  scanButton: {
    marginTop: theme.spacing(3),
    width: "100%",
    minHeight: 52,
    fontSize: "1.05rem",
    borderRadius: 14,
    backgroundColor: "#003350",
    color: "#FFFFFF",
    boxShadow: "0 8px 20px rgba(0, 51, 80, 0.18)",
    "&:hover": { backgroundColor: "#002635" },
    "& .MuiButton-label": {
      display: "inline-flex",
      alignItems: "center",
      gap: theme.spacing(1),
    },
  },
  scanIcon: {
    fontSize: 22,
  },
}));

export default useStyles;
